// API Configuration
// Primary: Supabase Edge Functions. EC2 fallback is DEPRECATED.
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || ''
const SUPABASE_FUNCTIONS_URL = process.env.REACT_APP_SUPABASE_FUNCTIONS_URL ||
  (SUPABASE_URL ? `${SUPABASE_URL}/functions/v1` : '');

// DEPRECATED: EC2 fallback — will be removed once Supabase migration is verified complete.
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

if (!SUPABASE_FUNCTIONS_URL && typeof console !== 'undefined') {
  console.warn(
    '⚠️ [DEPRECATED] REACT_APP_SUPABASE_URL is not set. ' +
    'Falling back to EC2 server. This will be removed in a future release.'
  )
}

export const API_ENDPOINTS = {
  // Authentication - Using Supabase Edge Functions
  LOGIN: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/auth-login` : `${API_BASE_URL}/api/login`,
  ADMIN_LOGIN: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/auth-admin-login` : `${API_BASE_URL}/api/admin/login`,
  SEND_OTP: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/auth-send-otp` : `${API_BASE_URL}/api/send-otp`,
  VERIFY_OTP_RESET_PASSWORD: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/auth-verify-otp-reset-password` : `${API_BASE_URL}/api/reset-password`,
  RESET_PASSWORD: `${API_BASE_URL}/api/reset-password`, // Keep for backward compatibility
  LOGOUT: `${API_BASE_URL}/api/logout`, // Keep EC2 for now if not migrated
  
  // Student Management - Direct Supabase queries (via supabaseService)
  // These are handled directly by Supabase client, not via API
  MAJOR_SUBJECTS: 'supabase:major_subjects', // Marker for direct Supabase query
  MINOR_SUBJECTS: 'supabase:minor_subjects', // Marker for direct Supabase query
  TEACHERS: 'supabase:teachers', // Marker for direct Supabase query
  GALLERY_PHOTOS: 'supabase:gallery_photos', // Marker for direct Supabase query
  
  // Student Management - Using Supabase Edge Functions
  CALCULATE_FEE: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/calculate-fee` : `${API_BASE_URL}/api/calculate-fee`,
  PROCESS_REGISTRATION: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/register-student` : `${API_BASE_URL}/api/register-student`,
  PROCESS_UPI_PAYMENT: `${API_BASE_URL}/api/process-upi-payment`, // Keep EC2 for now if not migrated
  STUDENTS: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/get-students` : `${API_BASE_URL}/api/students`,
  STUDENT_DETAILS: `${API_BASE_URL}/api/student`, // Keep EC2 for now if not migrated
  DELETE_STUDENT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/delete-student` : `${API_BASE_URL}/api/student`,
  PAYMENTS: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/get-payments` : `${API_BASE_URL}/api/payments`,
  PAYMENT_SUMMARY: `${API_BASE_URL}/api/payment-summary`, // Keep EC2 for now if not migrated
  UPDATE_PAYMENT_STATUS: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/update-payment-status` : `${API_BASE_URL}/api/update-payment-status`,
  
  // Razorpay Payment - Using Supabase Edge Functions
  VERIFY_STUDENT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/verify-student` : `${API_BASE_URL}/api/payments/verify-student`,
  GET_STUDENT_BY_REG: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/get-student-by-reg` : `${API_BASE_URL}/api/student-by-reg`,
  CREATE_RAZORPAY_ORDER: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/create-razorpay-order` : `${API_BASE_URL}/api/payments/create-razorpay-order`,
  VERIFY_RAZORPAY_PAYMENT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/verify-razorpay-payment` : `${API_BASE_URL}/api/payments/verify-razorpay-payment`,
  
  // Admin Management - Using Supabase Edge Functions
  MANAGE_MAJOR_SUBJECT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/admin/manage-subject` : `${API_BASE_URL}/api/admin/major-subject`,
  MANAGE_MINOR_SUBJECT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/admin/manage-subject` : `${API_BASE_URL}/api/admin/minor-subject`,
  DELETE_MAJOR_SUBJECT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/admin/delete-subject` : `${API_BASE_URL}/api/admin/major-subject`,
  DELETE_MINOR_SUBJECT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/admin/delete-subject` : `${API_BASE_URL}/api/admin/minor-subject`,
  MANAGE_FEE_STRUCTURE: `${API_BASE_URL}/api/admin/fee-structure`, // Keep EC2 for now if not migrated
  MANAGE_TEACHER: `${API_BASE_URL}/api/admin/teacher`, // Handled by supabaseService directly
  DELETE_TEACHER: `${API_BASE_URL}/api/admin/teacher`, // Handled by supabaseService directly
  UPLOAD_GALLERY_PHOTO: `${API_BASE_URL}/api/admin/upload-gallery-photo`, // Handled by supabaseService directly
  DELETE_GALLERY_PHOTO: `${API_BASE_URL}/api/admin/delete-gallery-photo`, // Handled by supabaseService directly
  ADMIN_STATS: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/admin/stats` : `${API_BASE_URL}/api/admin/stats`,
  FEE_STRUCTURE: `${API_BASE_URL}/api/admin/fee-structure`, // Keep EC2 for now if not migrated
  UPDATE_STUDENT: SUPABASE_FUNCTIONS_URL ? `${SUPABASE_FUNCTIONS_URL}/admin-update-student` : `${API_BASE_URL}/api/admin/student`,
  
  // PayPal (disabled but endpoints exist)
  PAYPAL_ORDERS: `${API_BASE_URL}/api/paypal/create-order`,
  PAYPAL_CAPTURE: `${API_BASE_URL}/api/paypal/capture-order`,
  STUDENT_PAYPAL_ORDERS: `${API_BASE_URL}/api/paypal/create-student-order`,
  
  // OAuth Admin Authentication
  VERIFY_ADMIN_TOKEN: `${API_BASE_URL}/api/admin/verify-token`, // Keep EC2 for now if not migrated
  ADMIN_EMAILS: `${API_BASE_URL}/api/admin/emails`, // Keep EC2 for now if not migrated
  ADD_ADMIN_EMAIL: `${API_BASE_URL}/api/admin/emails`, // Keep EC2 for now if not migrated
  DELETE_ADMIN_EMAIL: `${API_BASE_URL}/api/admin/emails`, // Keep EC2 for now if not migrated
};

export default API_BASE_URL;
